// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_BillingSettingsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_BillingSettingsInput — body for POST /subscriptions/billing-settings.
 *
 * The field is optional; omitting it leaves the setting unchanged.
 *
 * Optional:
 *   billing_grace_days (int|null) — days of grace after PAYMENT_OVERDUE
 */
import { registerContract } from './validate'

export interface Subscriptions_BillingSettingsInput {
billing_grace_days?: number
}

registerContract('Subscriptions_BillingSettingsInput', {
  billing_grace_days: { type: 'number',  required: false },
})
